var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.goToExport()}}},[_vm._v("\n    匯出表單\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }